import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { StoreState } from '../../store/createStore';

import {
  Container,
  ContainerMenu,
} from './styles';

import { openMenuBase } from '../../store/modules/parameter/actions';
import { NavLink } from '../../components/NavLink';

const BaseMenu: React.FC = () => {

  const { openMenu } = useSelector((state: StoreState) => state.parameter);
  
  const dispatch = useDispatch();
  
  // const handledSigout = useCallback(() => {
  //   dispatch(signOut());
  //   dispatch(openMenuBase());
  // }, [dispatch]);

  const handledOpenMenu = useCallback((e, bForce : boolean) => {
    if ((e && e.nativeEvent?.target?.title === "space-out") || bForce === true)
      dispatch(openMenuBase());
  }, [dispatch]);

  return (
    <Container open={openMenu} title="space-out" onClick={(e) => handledOpenMenu(e, false)}>
        <ContainerMenu title="space-in">
          <NavLink bMobile/>
        </ContainerMenu>
      {/* <ContainerMenuRight  /> */}
    </Container>
  );
};

export default BaseMenu;